import { render } from "./red-ac.vue?vue&type=template&id=46d8fc1c&scoped=true"
import script from "./red-ac.vue?vue&type=script&lang=js"
export * from "./red-ac.vue?vue&type=script&lang=js"

import "./red-ac.vue?vue&type=style&index=0&id=46d8fc1c&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d8fc1c"]])

export default __exports__